import React from 'react';
import { QuickServiceTileSection } from './QuickServiceTileSection';
import { buildOrderedQuickTiles, type CmsTopicSections } from '../utils/resolveQuickSection';

const TILE_ORDER = ['towing', 'roadside-assist', 'accident-help', 'vehicle-lockout'] as const;

const TILE_ICONS: Record<string, string> = {
  towing: 'ti-tir',
  'roadside-assist': 'ti-car-crash',
  'accident-help': 'ti-ambulance',
  'vehicle-lockout': 'ti-lock-open',
};

export interface TowingAssistanceQuickSectionProps {
  onSelect: (categoryId: string, slug: string) => void;
  topicSections: CmsTopicSections;
}

export const TowingAssistanceQuickSection: React.FC<TowingAssistanceQuickSectionProps> = ({
  onSelect,
  topicSections,
}) => (
  <QuickServiceTileSection
    id="towing"
    title="Emergency Assistance"
    items={buildOrderedQuickTiles('emergency', TILE_ORDER, TILE_ICONS, topicSections)}
    onSelect={onSelect}
    variant="towing"
    labelInside
  />
);
